module.exports = __webpack_public_path__ + "img/nparra.feed6849.jpg";